import { render, staticRenderFns } from "./BulkResultModal.vue?vue&type=template&id=19b19a88"
import script from "./BulkResultModal.vue?vue&type=script&lang=js"
export * from "./BulkResultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports